import VipAccessFlow from './VipAccessFlow';
export default VipAccessFlow;
